import type { ParentComponent } from "solid-js";
import "./CardList.css";
export const CardList: ParentComponent = ({ children }) => {
	return <div class="gvtui-card-list">{children}</div>;
};
